export enum SavedViewsMessage {
  DeleteScreenSuccess = 'Screen "{screenName}" has been deleted.',
  DeleteViewSuccess = 'View "{viewName}" has been deleted.',
}
